import { smartAxios } from "../axios/Axios"
import { excludeClientEndpoints } from "./excludeClientEndpoints"
import { IDeleteExclude } from "./exludeModel"

export const postInstagramExclude = (clients: string[]) => {
    return smartAxios.post(excludeClientEndpoints.postInstagramExclude, {
        excluded_usernames: clients
    })
}
export const postWhatsappExclude = (clients: string[]) => {
    return smartAxios.post(excludeClientEndpoints.postWhatsappExclude, {
        excluded_phones: clients
    })
}
export const postTelegramExclude = (clients: string[]) => {
    console.log("clintes => ", clients);
    
    return smartAxios.post(excludeClientEndpoints.postTelegramExclude, {
        excluded_usernames: clients
    })
}
export const getExcludeProfiles = () => {
    return smartAxios.get(excludeClientEndpoints.getExcludeProfiles)
}
export const deleteExcludeClient = (data: IDeleteExclude) => {
    return smartAxios.delete(`${excludeClientEndpoints.deleteExcludeClient}${data.id}/${data.platform}/`)
}